<template>
    <div class="filter-outer">
        <div class="filter-overlay"></div>
        <div class="dropdown-filter"
             v-click-outside="hideFilter">
            <ul>
                <li v-for="(filter, index) in filters">
                    <div class="form-item form-checkbox">
                        <input type="checkbox"
                               name="agree"
                               :id="'filter_' + index"
                               @click="setFilter($event, index)">
                        <label :for="'filter_' + filter">{{ filter }}</label>
                        <div class="check"></div>
                        <p class="field-error--description field-error--description--white" v-show="errors.has('agree') && showErrors">{{ errors.first('agree') }}</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import ClickOutside from 'vue-click-outside';
    export default {
        props: ['filters'],
        computed: {
            open () {
                return this.$store.getters.commissionsFilter;
            }
        },
        methods: {
            hideFilter () {
                if (this.open) {
                    this.$store.commit('commissionsFilterOff');
                }
            },

            /**
             * Set filter
             * @param event
             * @param value
             */
            setFilter (event, value) {
                let checked = event.target.checked;

                if (checked) {
                    this.$store.commit('commissionsAddFilter', value);
                } else {
                    this.$store.commit('commissionsRemoveFilter', value);
                }
                this.getData();
            },

            /**
             * Get data
             */
            getData () {
                let settings = this.$store.getters.commissionsSettings;

                this.$store.dispatch('loadCommissions', {
                    params: settings
                });
            },
        },
        mounted () {
            let defaultFilter = this.$store.getters.commissionsSettings.filter;

            for (let filter in defaultFilter) {
                document.querySelector('#filter_' + defaultFilter[filter]).checked = true;
            }

        },
        directives: {
            ClickOutside
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../../../assets/scss/_colors.scss';

    .dropdown-filter{
        position: absolute;
        top: 56px;
        left: 0;
        padding: 4px 11px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
        background-color: $white;
        z-index: 10;

        ul{
            margin: 0;

            .form-item{
                cursor: pointer;
                margin: 0;

                label{
                    margin: 0;
                }

                input{
                    cursor: pointer;
                }
            }
        }
    }

    @media(max-width: 991px){
        .filter-outer{
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 99
        }

        .filter-overlay{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.2);
            z-index: 1;
        }

        .dropdown-filter{
            position: relative;
            top: auto;
            left: auto;
            z-index: 2;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/commissions/commissions-table/BonusFilter.vue